// ─────────────────────────────────────────────────────────────────────────────
// version.ts — App version + canonical document title
//
// APP_VERSION is auto-bumped at build time by esbuild.pwa.mjs's
// `bumpAppVersion()` step (counts commits via `git rev-list --count
// HEAD`). The line below is the only one rewritten — keep its shape
// stable. Don't bump manually.
//
// APP_TITLE feeds document.title (browser tab + standalone-app chrome)
// from pwa_main.ts on boot. The vault's own name (folder-derived) no
// longer rides in the title — a stable name makes the tab recognisable
// regardless of which journal is open.
// ─────────────────────────────────────────────────────────────────────────────

export const APP_VERSION = 'c70e693';
export const APP_TITLE = `X.o Journal o.X v${APP_VERSION}`;
